export default "__VITE_PUBLIC_ASSET__eff9762c__"